export type ListItemLayout = { top: number; height: number };

export function getListLayout<T>(items: readonly T[], itemHeight: number | ((item: T) => number), gap: number) {
	let height = 0;
	const rows = items.map(item => {
		const row = { top: height, height: typeof itemHeight === 'number' ? itemHeight : itemHeight(item) };
		height += row.height + gap;
		return row;
	});
	return { rows, height };
}

/** Find the viewport slice without walking every item on each scroll. */
export function getVisibleRange(rows: readonly ListItemLayout[], top: number, height: number, overscan: number) {
	const lowerBound = (position: number, edge: 'top' | 'bottom') => {
		let low = 0;
		let high = rows.length;
		while (low < high) {
			const middle = Math.floor((low + high) / 2);
			const row = rows[middle];
			const before = edge === 'bottom' ? row.top + row.height <= position : row.top < position;
			if (before) low = middle + 1;
			else high = middle;
		}
		return low;
	};
	return {
		start: Math.max(0, lowerBound(top, 'bottom') - overscan),
		end: Math.min(rows.length, lowerBound(top + height, 'top') + overscan),
	};
}
